import React from "react";
import {
  FormControl,
  FormLabel,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";

const RecordedContactInfoStep = ({
  formData,
  formErrors,
  handleChange,
  fields,
  loadingUsers,
  supervisorOptions,
}) => {
  return (
    <>
      {fields.map((field) => {
        const errorMsg = formErrors[field.key];
        return (
          <FormControl
            key={field.key}
            fullWidth
            error={Boolean(errorMsg)}
            sx={{ mb: 2 }}
          >
            <FormLabel>{field.name}</FormLabel>
            {field.key === "supervisorId" ? (
              loadingUsers ? (
                <CircularProgress size={24} />
              ) : (
                <Select
                  name={field.key}
                  value={formData[field.key] || ""}
                  onChange={handleChange}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Select a supervisor</em>
                  </MenuItem>
                  {supervisorOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              )
            ) : field.type === "select" ? (
              <Select
                name={field.key}
                value={formData[field.key] || ""}
                onChange={handleChange}
                displayEmpty
              >
                <MenuItem value="">
                  <em>Select an option</em>
                </MenuItem>
                {field.options?.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <TextField
                name={field.key}
                type={field.type}
                placeholder={field.placeholder || ""}
                value={formData[field.key] || ""}
                onChange={handleChange}
                fullWidth
                variant="outlined"
              />
            )}
            {errorMsg && <FormHelperText>{errorMsg}</FormHelperText>}
          </FormControl>
        );
      })}
    </>
  );
};

export default RecordedContactInfoStep;
